import { useState } from 'react';
import { dailyRankings, weeklyRankings } from '@/mocks/rankings';

export default function RankingSection() {
  const [tab, setTab] = useState<'daily' | 'weekly'>('daily');
  const rankings = tab === 'daily' ? dailyRankings : weeklyRankings;

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            排行榜
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            每日积分排行榜
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm">
            看看谁是今天的竞技王者，每日刷新，挑战更高名次
          </p>
        </div>

        <div className="flex justify-center mb-10">
          <div className="inline-flex bg-background-200/50 rounded-full p-1">
            <button
              onClick={() => setTab('daily')}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                tab === 'daily'
                  ? 'bg-background-50 text-foreground-900'
                  : 'text-foreground-500 hover:text-foreground-700'
              }`}
            >
              今日排行榜
            </button>
            <button
              onClick={() => setTab('weekly')}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                tab === 'weekly'
                  ? 'bg-background-50 text-foreground-900'
                  : 'text-foreground-500 hover:text-foreground-700'
              }`}
            >
              本周排行榜
            </button>
          </div>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 border-b border-background-200/60 text-xs font-medium text-foreground-400">
              <div className="col-span-1">排名</div>
              <div className="col-span-4">选手</div>
              <div className="col-span-3">参赛类别</div>
              <div className="col-span-2 text-right">积分</div>
              <div className="col-span-2 text-right">连胜</div>
            </div>

            {rankings.map((item, index) => (
              <div
                key={item.rank}
                className={`grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-6 py-4 items-center transition-colors hover:bg-background-50 ${
                  index < rankings.length - 1 ? 'border-b border-background-200/40' : ''
                }`}
              >
                <div className="col-span-1 flex items-center gap-2">
                  <span
                    className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${
                      item.rank === 1
                        ? 'bg-primary-500 text-background-50'
                        : item.rank === 2
                          ? 'bg-primary-400 text-background-50'
                          : item.rank === 3
                            ? 'bg-primary-300 text-background-50'
                            : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <span className="md:hidden text-xs font-medium text-foreground-500">名</span>
                </div>

                <div className="col-span-4 flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary-400 to-accent-400 flex items-center justify-center text-background-50 text-xs font-bold">
                    {item.name.charAt(0)}
                  </div>
                  <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                </div>

                <div className="col-span-3">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs">
                    {item.category}
                  </span>
                </div>

                <div className="col-span-2 text-right">
                  <span className="text-sm font-semibold text-foreground-900">{item.score.toLocaleString()}</span>
                </div>

                <div className="col-span-2 text-right flex items-center justify-end gap-2">
                  <span className="text-xs text-foreground-400">{item.streak}天</span>
                  {item.change === 'up' && <i className="ri-arrow-up-line text-accent-600 text-xs"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-red-500 text-xs"></i>}
                  {item.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-xs"></i>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}